// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a841cd29","101":"2c86e84e","266":"f6b4c472","267":"b627f4cb","305":"70902c8b","453":"5b5e23d0","466":"acc777e9","632":"21760165"}[chunkId] + ".chunk.js";
};